import React from 'react';
import { Form, Field } from 'react-final-form';
import { FormattedMessage } from 'react-intl';
import { renderPlaceholderTextField } from './fields';

import { checkEmail } from '../../helpers';

const validate = (values, props) => {
  const errors = {};
  const { messages } = props.i18n;

  const emailError = checkEmail(values.login, messages);

  if (emailError) errors.login = emailError;

  return errors;
};

/**
 * @typedef {object} SendActivationEmailFormProps
 * @property {object} [i18n]
 * @property {Function} [onSubmit]
 * @property {boolean} [fetching]
 */
const SendActivationEmailForm = (props) => {
  const { messages } = props.i18n;
  const { onSubmit, fetching } = props;

  return (
    <div>
      <Form onSubmit={onSubmit} validate={(values) => validate(values, props)}>
        {({ handleSubmit }) => (
          <form className="form-content" noValidate onSubmit={handleSubmit}>
            <p className="single">
              <FormattedMessage id="label.activation.link.expired" />
            </p>
            <div className="mt-15">
              <Field
                name="login"
                component={renderPlaceholderTextField}
                placeholder={messages['generic.email']}
                type="email"
              />
            </div>
            <button type="submit" className="btn btn-secondary mt-15" disabled={fetching}>
              <FormattedMessage id="label.activation.link.send" />
            </button>
          </form>
        )}
      </Form>
    </div>
  );
};

export default SendActivationEmailForm;
